import { forIn, isArray, random } from "lodash";
import { firestore, auth } from "../_firebase";
import Collection from "../_collections";

const extractFieldsForSearchFromFilter = filter => {
  if (!filter) {
    return null;
  }
  try {
    let extractedFields = {};

    forIn(filter, (value, key) => {
      if (typeof value === "number") {
        extractedFields[key] = value;
      } else if (typeof value === "boolean") {
        extractedFields[key] = !value;
      } else if (typeof value === "string") {
        extractedFields[key] = value;
      }
       else if (isArray(value)) {
        if (value.length !== 0) {
          extractedFields[key] = value[0].value;
        }
      }
    });
    return extractedFields;
  } catch (error) {
    return null;
  }
};
const constructQuery = options => {
  let query = firestore.collection(Collection.USERS);

  forIn(options, (value, key) => {
    if (key === "ageStart" || key === "ageEnd") {
      if (key === "ageStart") {
        query = query.where("age", ">=", value);
      } else {
        query = query.where("age", "<=", value);
      }
    } else {
      if(value){
        query = query.where(`${key}`, "==", value);
      }
      
    }
  });
  console.log(query);
  return query;
};
const performSearch = filter => {
  let promise = new Promise((resolve, reject) => {
    const getSearchCriteriaFromFilter = extractFieldsForSearchFromFilter(
      filter
    );
    const constructedQuery = constructQuery(getSearchCriteriaFromFilter);
    // let query = constructedQuery.limit(6).orderBy("age", "asc");
    let query = firestore.collection(Collection.USERS).limit(6).orderBy('age','asc');
    query
      .get()
      .then(results => {
        let searchResults = [];

        results.forEach(result => {
          searchResults.push({ ...result.data(), ...{ id: result.id } });
        });
        let hasMoreResults = results.size === 0 ? false : true;
        let lastResult = null;
        if (results.size !== 0) {
          lastResult = results.docs[results.docs.length - 1].id;
        }

        resolve({ results: searchResults, lastResult });
      })
      .catch(err => {
        console.log(err);
        reject("Please try again later");
      });
  });
  return promise;
};

const loadMoreResults = (lastResult, filter) => {
  let promise = new Promise((resolve, reject) => {
    const getSearchCriteriaFromFilter = extractFieldsForSearchFromFilter(
      filter
    );
    if (!lastResult) {
      reject("Please try again later");
    }
    // const constructedQuery = constructQuery(getSearchCriteriaFromFilter);
    firestore
      .collection(Collection.USERS)
      .doc(lastResult)
      .get()
      .then(doc => {
        if (doc.exists) {
          firestore.collection(Collection.USERS)
            .limit(6)
            .orderBy("age", "asc")
            .startAfter(doc)
            .get()
            .then(results => {
              let searchResults = [];

              results.forEach(result => {
                searchResults.push({ ...result.data(), ...{ id: result.id } });
              });
              let hasMoreResults = results.size === 0 ? false : true;
              let lastResult = null;
              if (results.size !== 0) {
                lastResult = results.docs[results.docs.length - 1].id;
              }

              resolve({ results: searchResults, lastResult });
            })
            .catch(err => {
              console.log(err);
              reject("Please try again later");
            });
        } else {
          reject("Please try again later");
        }
      })
      .catch(err => {
        console.log(err);
        reject("Please try again later");
      });
  });
  return promise;
};

const searchService = {
  performSearch,
  loadMoreResults
};
export default searchService;



// WEBPACK FOOTER //
// ./src/_services/searchService.js